module.exports = __webpack_public_path__ + "img/benefit-02-cropped.2d5bac2.jpg";